const SquareGrowthIcon = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 40C0 25.0461 0 17.5692 3.21539 12C5.32183 8.35154 8.35154 5.32183 12 3.21539C17.5692 0 25.0461 0 40 0C54.9539 0 62.4308 0 68 3.21539C71.6485 5.32183 74.6782 8.35154 76.7846 12C80 17.5692 80 25.0461 80 40C80 54.9539 80 62.4308 76.7846 68C74.6782 71.6485 71.6485 74.6782 68 76.7846C62.4308 80 54.9539 80 40 80C25.0461 80 17.5692 80 12 76.7846C8.35154 74.6782 5.32183 71.6485 3.21539 68C0 62.4308 0 54.9539 0 40Z"
        fill="#0E386D"
      />
      <path
        d="M56.6991 32.2583C57.7176 26.9473 53.0549 22.2846 47.7439 23.3031L32.4955 26.2276C29.1808 26.8633 26.5299 29.3723 25.6877 32.6326C24.0062 39.1419 30.0429 45.091 36.5247 43.1848C36.7037 43.1322 36.87 43.2985 36.8174 43.4775C34.9113 49.9594 40.8603 55.9961 47.3696 54.3146C50.6299 53.4724 53.139 50.8215 53.7747 47.5067L56.6991 32.2583Z"
        fill="white"
      />
      <path
        d="M27.4919 47.2071C27.98 46.7189 27.98 45.9275 27.4919 45.4393C27.0037 44.9512 26.2123 44.9512 25.7241 45.4393L23.3671 47.7964C22.8789 48.2845 22.8789 49.076 23.3671 49.5641C23.8552 50.0523 24.6467 50.0523 25.1349 49.5641L27.4919 47.2071Z"
        fill="white"
      />
      <path
        d="M33.3844 46.6178C33.8726 47.106 33.8726 47.8975 33.3844 48.3856L31.0274 50.7426C30.5393 51.2308 29.7478 51.2308 29.2596 50.7426C28.7715 50.2545 28.7715 49.463 29.2596 48.9749L31.6167 46.6178C32.1048 46.1297 32.8963 46.1297 33.3844 46.6178Z"
        fill="white"
      />
      <path
        d="M34.563 54.2782C35.0511 53.79 35.0511 52.9986 34.563 52.5104C34.0748 52.0222 33.2833 52.0222 32.7952 52.5104L30.4382 54.8674C29.95 55.3556 29.95 56.147 30.4382 56.6352C30.9263 57.1233 31.7178 57.1233 32.2059 56.6352L34.563 54.2782Z"
        fill="white"
      />
    </svg>
  )
}

export default SquareGrowthIcon
